import { apiRequest } from "../../utils/apiUtils";

export const noticeApi = {
  getPopupList: () =>
    apiRequest<any>("get", "/popup-notice/list", { fullResponse: true }),
  getNoticeList: (category?: string) =>
    apiRequest<any>("get", `/notice${category ? `?category=${category}` : ""}`, { fullResponse: true }),
  getFaqList: (category?: string) => apiRequest<any>("get", `/faq${category ? `?category=${category}` : ""}`, { fullResponse: true }),
  getEventBanner: () =>
    apiRequest<any>("get", "/runner-event/list", { fullResponse: true }),
};
